// Удаление вершины линии редактора (ластик). Крайняя вершина отрезает свой
// лег; внутренняя склеивает два соседних лега в один прямой между оставшимися
// соседями. rerouteIndex - индекс склеенного лега, который нужно заново
// проложить по графу (если хоть один из слитых был проложен по графу), иначе
// null. Вход не мутируется.
export type Coordinate = [number, number];

export interface RemovableLeg {
  geometry: Coordinate[];
  routed: boolean;
  status: "straight" | "routed" | "fallback";
}

export interface RemoveVertexResult<L extends RemovableLeg> {
  vertices: Coordinate[];
  legs: L[];
  rerouteIndex: number | null;
}

export const removeVertexAt = <L extends RemovableLeg>(
  vertices: Coordinate[],
  legs: L[],
  index: number
): RemoveVertexResult<L> => {
  const n = vertices.length;
  if (index < 0 || index >= n) return { vertices: vertices.slice(), legs: legs.slice(), rerouteIndex: null };
  if (n === 1) return { vertices: [], legs: [], rerouteIndex: null };
  if (index === 0) return { vertices: vertices.slice(1), legs: legs.slice(1), rerouteIndex: null };
  if (index === n - 1) return { vertices: vertices.slice(0, -1), legs: legs.slice(0, -1), rerouteIndex: null };

  const nextVertices = vertices.slice();
  nextVertices.splice(index, 1);
  const routed = Boolean(legs[index - 1]?.routed || legs[index]?.routed);
  const merged = {
    ...legs[index - 1],
    geometry: [nextVertices[index - 1], nextVertices[index]],
    routed,
    status: "straight",
  } as L;
  const nextLegs = legs.slice();
  nextLegs.splice(index - 1, 2, merged);
  return { vertices: nextVertices, legs: nextLegs, rerouteIndex: routed ? index - 1 : null };
};
